<template>
    <div class="tenant-form">
      <h2>Edit Landlord</h2>
      <form @submit.prevent="submitTenant">
        <!-- Tenant Type Section -->
        <div class="section">
          <h3>Tenant Type</h3>
          <div class="form-group">
            <label for="type">Type:</label>
            <select id="type" v-model="tenant.type" required>
              <option value="Residential">Residential</option>
              <option value="Commercial">Commercial</option>
            </select>
            <br>
            <div class="form-group">
              <label for="display-as">Display As:</label>
              <input type="text" id="display-as" v-model="tenant.displayAs" required />
            </div>
          </div>
        </div>
  
        <!-- Residential Details -->
        <div v-if="tenant.type === 'Residential'" class="section">
          <h3>Residential Details</h3>
          <div class="form-group">
            <label for="first-name">First Name:</label>
            <input type="text" id="first-name" v-model="tenant.person.firstName" required />
          </div>
          <div class="form-group">
            <label for="surname">Surname:</label>
            <input type="text" id="surname" v-model="tenant.person.surname" required />
          </div>
          <div class="form-group">
            <label for="date-of-birth">Date of Birth:</label>
            <input type="date" id="date-of-birth" v-model="tenant.person.dateOfBirth" required />
          </div>
          <div class="form-group">
            <label for="identifier">Identifier (RSA ID/Passport):</label>
            <input type="text" id="identifier" v-model="tenant.identifier" required />
          </div>
        </div>
  
        <!-- Contact Information -->
        <div class="section">
          <h3>Contact Information</h3>
          <div class="form-group">
            <label for="email">Email:</label>
            <input type="email" id="email" v-model="tenant.email" required />
          </div>
          <div class="form-group">
            <label for="number">Phone Number:</label>
            <input type="tel" id="number" v-model="tenant.number" required />
          </div>
        </div>
  
        <!-- Commercial Details -->
        <div v-if="tenant.type === 'Commercial'" class="section">
          <h3>Commercial Details</h3>
          <div class="form-group">
            <label for="legal-name">Legal Name:</label>
            <input type="text" id="legal-name" v-model="tenant.legalName" required />
          </div>
          <div class="form-group">
            <label for="trading-as">Trading As:</label>
            <input type="text" id="trading-as" v-model="tenant.tradingName" required />
          </div>
          <div class="form-group">
            <label for="registration-number">Registration Number:</label>
            <input type="text" id="registration-number" v-model="tenant.registrationNumber" required />
          </div>
          <div class="form-group">
            <label for="trust-npo-gov-number">Trust/NPO/Gov Number:</label>
            <input type="text" id="trust-npo-gov-number" v-model="tenant.trustNumber" required />
          </div>
          <div class="form-group">
            <label for="vat-number">VAT Number:</label>
            <input type="text" id="vat-number" v-model="tenant.vatNumber" required />
          </div>
        </div>
  
        <!-- Address Information -->
        <div class="section">
          <h3>Address Information</h3>
          <div class="form-group">
            <label for="street">Street:</label>
            <input type="text" id="street" v-model="tenant.address.street" required />
          </div>
          <div class="form-group">
            <label for="city">City:</label>
            <input type="text" id="city" v-model="tenant.address.city" required />
          </div>
          <div class="form-group">
            <label for="state">State/Province:</label>
            <input type="text" id="state" v-model="tenant.address.state" required />
          </div>
          <div class="form-group">
            <label for="postal-code">Postal Code:</label>
            <input type="text" id="postal-code" v-model="tenant.address.postalCode" required />
          </div>
          <div class="form-group">
            <label for="country">Country:</label>
            <input type="text" id="country" v-model="tenant.address.country" required />
          </div>
        </div>
  
        <!-- Bank Account Details -->
        <div class="section">
          <h3>Bank Account Details</h3>
          <div class="form-group">
            <label for="account-name">Account Name:</label>
            <input type="text" id="account-name" v-model="tenant.bankAccount.name" />
          </div>
          <div class="form-group">
            <label for="account-number">Account Number:</label>
            <input type="text" id="account-number" v-model="tenant.bankAccount.number" />
          </div>
          <div class="form-group">
            <label for="selected-bank">Bank Name:</label>
            <input type="text" id="selected-bank" v-model="tenant.bankAccount.bank" />
          </div>
          <div class="form-group">
            <label for="account-type">Account Type:</label>
            <input type="text" id="account-type" v-model="tenant.bankAccount.type" />
          </div>
          <div class="form-group">
            <label for="branch-name">Branch Name:</label>
            <input type="text" id="branch-name" v-model="tenant.bankAccount.branchName" />
          </div>
          <div class="form-group">
            <label for="branch-code">Branch Code:</label>
            <input type="text" id="branch-code" v-model="tenant.bankAccount.branchCode" />
          </div>
        </div>
  
        <!-- Submit Button -->
        <button type="submit" :disabled="loading">Update Landlord</button>
      </form>
    </div>
  </template>
  
  <script>
  import {
    getDoc,
    doc,
    updateDoc,
    getDocs,
    collection,
    getFirestore,
    addDoc,
    deleteDoc,
  } from "firebase/firestore";
  import { getAuth } from "firebase/auth";

const db = getFirestore();
const auth = getAuth();
  
  export default {
    data() {
      return {
        tenant: {
          entityId: "",
          reference: "",
          type: "Residential", // Default value
          legalName: "",
          tradingName: "",
          registrationNumber: "",
          trustNumber: "",
          vatNumber: "",
          email: "",
          number: "",
          address: {
            street: "",
            city: "",
            state: "",
            postalCode: "",
            country: "",
          },
          person: {
            firstName: "",
            surname: "",
            dateOfBirth: "",
          },
          bankAccount: {
            name: "",
            number: "",
            bank: "",
            type: "",
            branchName: "",
            branchCode: "",
          },
          displayAs: "",
          userUid: "",
        },
        loading: false,
      };
    },
    mounted() {
      const tenantId = this.$route.params.id;
      this.loadTenantData(tenantId);
    },
    methods: {
      async loadTenantData(tenantId) {
        try {
          const tenantDocRef = doc(db, "landlords", tenantId);
          const tenantDoc = await getDoc(tenantDocRef);
          if (tenantDoc.exists()) {
            this.tenant = tenantDoc.data();
          } else {
            alert("Landlord not found.");
            this.$router.push({ path: "/landlords" });
          }
        } catch (error) {
          console.error("Error loading tenant data:", error);
          alert("Error loading tenant data.");
        }
      },
      async submitTenant() {
        if (this.loading) return;
        this.loading = true;
  
        try {
          const user = auth.currentUser;
          if (!user) {
            alert("You must be logged in to edit a tenant.");
            this.loading = false;
            return;
          }
  
          this.tenant.userUid = user.uid;
  
          const tenantDocRef = doc(db, "landlords", this.$route.params.id);
          await updateDoc(tenantDocRef, this.tenant);
  
          alert("Landlord updated successfully!");
          this.$router.push({ path: "/landlords", query: { type: "landlords" } });
        } catch (error) {
          console.error("Error updating tenant:", error);
          alert("Error updating tenant. Please try again later.");
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  

  <style scoped>
  .tenant-form {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
  }
  
  h2,
  h3 {
    margin-bottom: 20px;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  input,
  select {
    width: 100%;
    padding: 8px;
    margin-top: 5px;
    border: 2px solid #d5d3d3; /* Darker border */
    border-radius: 4px;
    outline: none;
  }
  
  input:focus,
  select:focus {
    border-color: #4caf50; /* Highlight on focus */
  }
  
  button {
    padding: 10px 20px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
  }
  
  button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  .section {
    margin-bottom: 30px;
    border: 1px solid #ddd;
    padding: 15px;
    border-radius: 5px;
  }
  
  .section h3 {
    margin-top: 0;
  }
  </style>